import { render, staticRenderFns } from "./billboardBannerTop.vue?vue&type=template&id=0669b2f3&scoped=true&"
import script from "./billboardBannerTop.vue?vue&type=script&lang=js&"
export * from "./billboardBannerTop.vue?vue&type=script&lang=js&"
import style0 from "./billboardBannerTop.vue?vue&type=style&index=0&id=0669b2f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669b2f3",
  null
  
)

export default component.exports